import { Injectable } from '@angular/core';
import { Point } from '../generated/models_pb';

@Injectable({
  providedIn: 'root'
})
export class IndexPointService {

  connectTwoIndexes(firstIndex: number, secondIndex: number, totalColumns: number): Point.AsObject[] {
    if (firstIndex === -1) {
      firstIndex = secondIndex;
    }
    const firstPoint: Point.AsObject = this.convertToPoint(firstIndex, totalColumns);
    const secondPoint: Point.AsObject = this.convertToPoint(secondIndex, totalColumns);
    return this.connectTwoPoints(firstPoint, secondPoint);
  }

  connectTwoPoints(firstPoint: Point.AsObject, secondPoint: Point.AsObject): Point.AsObject[] {
    let x1: number = firstPoint.x;
    let y1: number = firstPoint.y;
    const x2: number = secondPoint.x;
    const y2: number = secondPoint.y;

    const dx: number = Math.abs(x2 - x1);
    const dy: number = Math.abs(y2 - y1);
    const sx: number = (x1 < x2) ? 1 : -1;
    const sy: number = (y1 < y2) ? 1 : -1;
    let err: number = dx - dy;

    const points: Point.AsObject[] = [];
    let maxIterations: number = 1000;
    while (maxIterations-- > 0) {
      maxIterations--;
      points.push({ x: x1, y: y1 });
      if (this._samePoint(x1, y1, x2, y2)) {
        break;
      }
      const e2: number = 2 * err;
      if (e2 > -dy) {
        err -= dy;
        x1 += sx;
      }
      if (e2 < dx) {
        err += dx;
        y1 += sy;
      }
    }

    return points;
  }

  private _samePoint(x1: number, y1: number, x2: number, y2: number): boolean {
    return x1 === x2 && y1 === y2;
  }

  convertToPoint(index: number, totalColumns: number): Point.AsObject {
    const row: number = Math.floor(index / totalColumns);
    const col: number = index % totalColumns;
    return { x: col, y: row };
  }

  convertToIndex(point: Point.AsObject, totalColumns: number): number {
    return point.y * totalColumns + point.x;
  }

  
  public getNeighboursIndexes(index: number, totalColumns: number, totalRows: number, neighbourDistance: number = 1) : number[] {
    const neighbours: number[] = [];
    const x: number = index % totalColumns;
    const y: number = Math.floor(index / totalColumns);
    for( let i: number = -neighbourDistance; i <= neighbourDistance; i++) {
      for( let j: number = -neighbourDistance; j <= neighbourDistance; j++) {
        const neighbourX: number = x + i;
        const neighbourY: number = y + j;
        if(neighbourX >= 0 && neighbourX < totalColumns && neighbourY >= 0 && neighbourY < totalRows) {
          neighbours.push(neighbourY * totalColumns + neighbourX);
        }
      }
    }
    return neighbours;
  }
}